import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  LockOutlined,
  UserOutlined,
  HomeOutlined,
  QuestionCircleOutlined,
  LoginOutlined,
  MailOutlined,
  SafetyOutlined,
  GlobalOutlined,
  IdcardOutlined,
} from "@ant-design/icons";
import {
  Button,
  Form,
  Input,
  Row,
  Col,
  Popover,
  FloatButton,
  Checkbox,
  TourProps,
  Tour,
  message,
} from "antd";
import "./SubscriptionStudio.css";
import { Studio, emptyStudio } from "../studio/interfaces/studio";
import { addMedicalStudioX, checkCfAvailability, checkDoctorEmailAvailability, checkDoctorUsernameAvailability, checkStudioName, checkUsernameAvailability } from "./utils";
import { LOGIN_PATH, REGISTER_PATH } from "../env";
import TutorialButtonYouTube from "../exams/TutorialButtonYouTube";

//All Stuff For Submit
export interface StudioAdd extends Studio {
  usernameMaster: string;
  emailMaster: string;
  passwordMaster: string;
  passwordMasterConfirmation: string;
}

const SubscriptionStudio: React.FC = () => {
  const [visible, setVisible] = useState(false);

  const search = useLocation().search;

  //Tour
  const menupic =
    "https://www.physiocheck.it/wp-content/uploads/2024/02/physiocxhe-mernu.gif";

  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  const ref6 = useRef(null);
  const ref7 = useRef(null);
  const ref8 = useRef(null);
  const ref9 = useRef(null);
  const ref10 = useRef(null);

  const [open, setOpen] = useState<boolean>(false);

  const steps: TourProps["steps"] = [
    {
      title: "Iniziamo!",
      description:
        "Benvenuto nel form di iscrizione. Qui potrai inserire tutte le informazioni necessarie per completare la registrazione.",
    },
    {
      title: "Username",
      description:
        "Inserisci un nome utente univoco che utilizzerai per accedere al tuo account.",
      target: () => ref2.current,
    },
    {
      title: "Email",
      description:
        "Inserisci un indirizzo email valido da associare al tuo account.",
      target: () => ref3.current,
    },
    {
      title: "Password",
      description: "Crea una password sicura per proteggere il tuo account.",
      target: () => ref4.current,
    },
    {
      title: "Conferma Password",
      description:
        "Inserisci nuovamente la password per confermare la correttezza.",
      target: () => ref5.current,
    },
    {
      title: "Studio Login",
      description:
        "Inserisci un nome studio identificativo che utilizzerai per loggarti.",
      target: () => ref6.current,
    },
    {
      title: "Nome Studio",
      description: "Inserisci il nome completo della tua attività.",
      target: () => ref7.current,
    },
    {
      title: "Partita IVA o Codice Fiscale",
      description: "Inserisci il tuo numero di Partita IVA o Codice Fiscale.",
      target: () => ref8.current,
    },
    {
      title: "Conferma Privacy",
      description:
        "Assicurati di aver letto e accettato l'informativa sulla privacy prima di procedere.",
      target: () => ref9.current,
    },
    {
      title: "Iscriviti",
      description:
        "Dopo aver completato tutti i campi richiesti, fai clic sul pulsante 'Iscriviti' per inviare il modulo di registrazione.",
      target: () => ref10.current,
    },
  ];

  const contentx = (
    <>
      <Row>
        <Button onClick={() => setOpen(true)}>Tour Guidato</Button>

        <Button href="https://www.physiocheck.it/richiesta-assistenza/">
          Contattaci
        </Button>
      </Row>
    </>
  );

  const contenty = (
    <>
      <Row>
        <Button href={"/app" + LOGIN_PATH}>Vai al Login</Button>
      </Row>
    </>
  );

  // Visible or Not

  const [startVisible, setStartVisible] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [docVisible, setDocVisible] = useState(true);
  const [studioVisible, setStudioVisible] = useState(false);
  const [form] = Form.useForm();

  // Ottieni la data attuale
  const currentDate = new Date();
  const fbStart = 64;

  // Aggiungi 15 giorni alla data attuale
  const moreFif = new Date(currentDate.setDate(currentDate.getDate() + 15));

  // Ottieni la rappresentazione ISO 8601 della data più 15 giorni
  const formattedDate = moreFif.toISOString();

  const [addStudio, setAddStudio] = useState<StudioAdd>({
    ...emptyStudio,
    logo: "example.png",
    usernameMaster: "",
    emailMaster: "",
    passwordMaster: "",
    passwordMasterConfirmation: "",
    subscribedEnd: moreFif,
    fbSizeMax: fbStart,
  });

  //submit data

  const ender = () => {
    form
      .validateFields()
      .then((values) => {
        console.log("Dati validati:", values);
        // Qui esegui l'aggiunta dello studio medico utilizzando i valori validati
        return addMedicalStudioX(addStudio); // Aggiungi il return qui
      })
      .then((result) => {
        if (result === "ok") {
          // Se l'aggiunta ha successo, mostra un messaggio di conferma
          console.log("Iscrizione completata con successo!");
          message.success("Iscrizione completata con successo!");
          // Reindirizza l'utente dopo 2 secondi
          setTimeout(() => {
            window.location.href =
              "https://www.physiocheck.it/conferma-iscrizione";
          }, 2000);
        } else {
          // Se la risposta è un messaggio di errore
          console.log("Errore durante l'aggiunta dello studio medico:", result);
          message.error(result);
        }
      })
      .catch((error) => {
        // Gestisci altri errori (se presenti)
        console.log("Errori di validazione:", error);
        message.error(
          "Si sono verificati errori durante la validazione dei dati. Riprova o contatta l'assistenza."
        );
      });
  };

  const onFinishFailed = (errorInfo: any) => {
    message.error("Errore: controlla e completa tutti i campi richiesti!");
  };




  
    // Nuovo validator asincrono per la disponibilità dello username
    const validateUsernameAvailability = async (_: any, value: string) => {
      if (!value) {
        return Promise.reject(new Error("Inserisci l'username"));
      }
      if (value.length < 4) {
        return Promise.reject(
          new Error("L'username deve contenere almeno 4 lettere")
        );
      }
      const availabilityStatus = await checkDoctorUsernameAvailability(value);
      console.log("Risposta del server per username:", availabilityStatus, "il value è:", value);
      if (Number(availabilityStatus) === 1) {
        return Promise.reject(new Error("Username già esistente, scegli un altro!"));
      } else if (Number(availabilityStatus) !== 0) {
        return Promise.reject(new Error("Errore di connessione o interno"));
      }
      return Promise.resolve();
    };
  

  //BACKGROUND

  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/app" + REGISTER_PATH) { 
      document.body.classList.add("subscription-page");
    } else {
      document.body.classList.remove("subscription-page");
    }

    // Cleanup function to remove the class when the component unmounts
    return () => {
      document.body.classList.remove("subscription-page");
    };
  }, [location.pathname]);

  //for Responsive
  const [width, setWidth] = useState(0);
  const handleResize = () => setWidth(window.innerWidth);

  useEffect(() => {
    //mount
    window.addEventListener("resize", handleResize);
    setWidth(window.innerWidth);
    //unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {width > 768 && (
        <>
          <Tour open={open} onClose={() => setOpen(false)} steps={steps} />
          <TutorialButtonYouTube
            video={
              "https://www.youtube.com/embed/V_CdIkZMuoc?si=c5IRQatCTRc4SnUP"
            }
            title={"Tutorial PhysiocheckApp | Iscrizione Utente"}
          />
          {startVisible && (
            <>
              <Row className="bodys">
                <Row className="Rower">
                  <Row>
                    <Col className="centerov" span={14}>
                      <div>
                        <h3 className="loginf">
                          <LockOutlined rev={undefined} /> REGISTRATI
                        </h3>
                        <p className="loginf2">Benvenuto in Physiocheck App</p>
                      </div>
                    </Col>
                    <Col className="center0" span={4}></Col>
                    <Col className="centero" span={6}>
                      <Form.Item>
                        <Button
                          ref={ref1}
                          type="primary"
                          onClick={() => {
                            setStartVisible(false), setModalVisible(true);
                          }}
                          className="login-boton"
                        >
                          Iscriviti
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Row>
              </Row>
            </>
          )}
          {modalVisible && (
            <>
              <Row className="bodys">
                <Row className="Rower">
                  <Form
                    form={form}
                    name="control-hooks"
                    onFinish={ender}
                    onFinishFailed={onFinishFailed}
                    layout="vertical"
                  >
                    <Row>
                      <Col span={24}>
                        <h3 className="moon">
                          <UserOutlined rev={undefined} /> MODULO DI ISCRIZIONE{" "}
                        </h3>
                      </Col>

                      <Col className="moon" span={12}>
                        <h4>Dati Dottore</h4>
                        <Col className="formode">

                        
                          <Form.Item
                            name="usernameMaster"
                            style={{ minWidth: "300px" }}
                            rules={[
                              {
                                required: true,
                                message: "Inserisci il tuo username!",
                              },
                              { validator: validateUsernameAvailability },
                            ]}
                          >
                            <Input
                              onChange={(e) =>
                                setAddStudio({
                                  ...addStudio,
                                  usernameMaster: e.target.value,
                                })
                              }
                              prefix={
                                <UserOutlined
                                  ref={ref2}
                                  className="site-form-item-icon"
                                  rev={undefined}
                                />
                              }
                              placeholder="Username Login"
                              className="all-login-formo"
                            />
                          </Form.Item>



                            <Form.Item
                            name="emailMaster"
                            style={{ minWidth: "300px" }}
                            rules={[
                              {
                              required: true,
                              type: "email",
                              message: "Inserisci un'email valida!",
                              },
                              {
                              validator: async (_, value) => {
                                if (!value) {
                                return Promise.reject(
                                  new Error("Inserisci un'email valida!")
                                );
                                }

                                // Chiamata per verificare se l'email è disponibile
                                const availabilityStatus = await checkDoctorEmailAvailability(value);

                                // Controllo del valore ritornato dal backend
                                if (availabilityStatus === "1") {
                                // Se l'email esiste già, mostra l'errore
                                return Promise.reject(
                                  new Error("Email già esistente, scegli un'altra email!")
                                );
                                } else if (availabilityStatus !== "0") {
                                // In caso di errore di connessione o errore interno
                                return Promise.reject(new Error("Errore di connessione o interno"));
                                }

                                // Se l'email è disponibile, accetta il valore
                                return Promise.resolve();
                              },
                              },
                            ]}
                            >
                            <Input
                              onChange={(e) =>
                              setAddStudio({
                                ...addStudio,
                                emailMaster: e.target.value,
                              })
                              }
                              prefix={
                              <MailOutlined
                                ref={ref3}
                                className="site-form-item-icon"
                                rev={undefined}
                              />
                              }
                              placeholder="Email"
                              className="all-login-formo"
                            />
                            </Form.Item>



                          <Form.Item
                            name="passwordMaster"
                            style={{ minWidth: "300px" }}
                            rules={[
                              {
                                required: true,
                                message: "Inserisci la tua password!",
                              },
                            ]}
                          >
                            <Input
                              onChange={(e) =>
                                setAddStudio({
                                  ...addStudio,
                                  passwordMaster: e.target.value,
                                })
                              }
                              prefix={
                                <LockOutlined
                                  ref={ref4}
                                  className="site-form-item-icon"
                                  rev={undefined}
                                />
                              }
                              type="password"
                              placeholder="Password"
                              className="all-login-formo"
                            />
                          </Form.Item>
                        </Col>
                        <Col className="formode">
                          <Form.Item
                            name="passwordMasterConfirmation"
                            style={{ minWidth: "300px" }}
                            dependencies={["passwordMaster"]}
                            rules={[
                              {
                                required: true,
                                message: "Conferma la tua password!",
                              },
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  if (
                                    !value ||
                                    getFieldValue("passwordMaster") === value
                                  ) {
                                    return Promise.resolve();
                                  }
                                  return Promise.reject(
                                    new Error("Le password non coincidono!")
                                  );
                                },
                              }),
                            ]}
                          >
                            <Input
                              onChange={(e) =>
                                setAddStudio({
                                  ...addStudio,
                                  passwordMasterConfirmation: e.target.value,
                                })
                              }
                              prefix={
                                <SafetyOutlined
                                  ref={ref5}
                                  className="site-form-item-icon"
                                  rev={undefined}
                                />
                              }
                              type="password"
                              placeholder="Conferma Password"
                              className="all-login-formo"
                            />
                          </Form.Item>
                        </Col>
                      </Col>
                      <Col className="moon" span={12}>
                        <h4>Dati Studio</h4>
                        <Col>

                        <Form.Item
                          name="nameSignIn"
                          rules={[
                            {
                              required: true,
                              message: "Inserisci il nome di login dello studio!",
                            },
                            {
                              validator: async (_, value) => {
                                if (!value) {
                                  return Promise.reject(
                                    new Error("Inserisci il nome di login dello studio!")
                                  );
                                }

                                // Chiamata per verificare se il nome dello studio è disponibile
                                const availabilityStatus = await checkUsernameAvailability(value);

                                if (Number(availabilityStatus) === 1) {
                                  return Promise.reject(
                                    new Error("Studio Login già esistente, scegli un altro nome!")
                                  );
                                } else if (Number(availabilityStatus) !== 0) {
                                  return Promise.reject(new Error("Errore di connessione o interno"));
                                }

                                // Se il nome utente è disponibile
                                return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <Input
                            value={addStudio.nameSignIn}
                            onChange={(e) =>
                              setAddStudio({
                                ...addStudio,
                                nameSignIn: e.target.value,
                              })
                            }
                            prefix={<HomeOutlined className="site-form-item-icon" rev={undefined} />}
                            placeholder="Studio Login"
                            className="all-login-formo"
                          />
                        </Form.Item>

                          <Form.Item
                            name="fullName"
                            rules={[
                              {
                                required: true,
                                message:
                                  "Inserisci il nome completo dello studio!",
                              },
                            ]}
                          >
                            <Input
                              onChange={(e) =>
                                setAddStudio({
                                  ...addStudio,
                                  fullName: e.target.value,
                                })
                              }
                              prefix={
                                <GlobalOutlined
                                  ref={ref7}
                                  className="site-form-item-icon"
                                  rev={undefined}
                                />
                              }
                              placeholder="Nome Studio"
                              className="all-login-formo"
                            />
                          </Form.Item>



                          <Form.Item
  name="vat"
  labelCol={{ span: 24 }}
  wrapperCol={{ span: 24 }}
  rules={[
    {
      required: true,
      message: "Inserisci la Partita IVA o Codice Fiscale!",
    },
    {
      validator: async (_, value) => {
        if (!value) {
          return Promise.reject(
            new Error("Inserisci la Partita IVA o Codice Fiscale!")
          );
        }

        // Controllo lunghezza valida per Codice Fiscale o Partita IVA
        if (value.length < 11 || value.length > 16) {
          return Promise.reject(new Error("C.F. o P.iva non valido!"));
        }

        // Chiamata per verificare se il codice fiscale è disponibile
        const availabilityStatus = await checkCfAvailability(value);

        // Controllo del valore ritornato dal backend
        if (availabilityStatus === "1") {
          // Se il codice fiscale esiste già, mostra l'errore
          return Promise.reject(
            new Error("Codice Fiscale già esistente, scegli un altro!")
          );
        } else if (availabilityStatus !== "0") {
          // In caso di errore di connessione o errore interno
          return Promise.reject(new Error("Errore di connessione o interno"));
        }

        // Se il codice fiscale è disponibile, accetta il valore
        return Promise.resolve();
      },
    },
  ]}
>
  <Input
    onChange={(e) =>
      setAddStudio({
        ...addStudio,
        vat: e.target.value,
      })
    }
    prefix={
      <IdcardOutlined
        ref={ref8}
        className="site-form-item-icon"
        rev={undefined}
      />
    }
    placeholder="P.Iva / Codice Fiscale"
    className="all-login-formo"
  />
</Form.Item>





                          <Form.Item
                            name="policy"
                            valuePropName="checked"
                            rules={[
                              {
                                validator: (_, value) =>
                                  value
                                    ? Promise.resolve()
                                    : Promise.reject(
                                        new Error(
                                          "Devi accettare la privacy policy!"
                                        )
                                      ),
                              },
                            ]}
                          >
                            <Checkbox required={true}>
                              <h5 ref={ref9}>
                                Acconsento al trattamento{" "}
                                <a href="https://www.physiocheck.it/privacy-policy/">
                                  Privacy & Policy.
                                </a>
                              </h5>
                            </Checkbox>
                          </Form.Item>
                        </Col>
                      </Col>
                      <Col className="center" span={10}></Col>
                      <Col className="center" span={4}>
                        <Form.Item>
                          <Button
                            ref={ref10}
                            type="primary"
                            htmlType="submit"
                            className="login-boton"
                          >
                            Iscriviti
                          </Button>
                        </Form.Item>
                      </Col>
                      <Col className="center" span={10}></Col>
                    </Row>
                  </Form>
                </Row>
              </Row>
            </>
          )}
        </>
      )}

      {width <= 768 && (
        <>
          <Tour open={open} onClose={() => setOpen(false)} steps={steps} />
          {startVisible && (
            <>
              <Row className="bodysi">
                <Row className="Rower-m">
                  <Row>
                    <Col className="centerov" span={14}>
                      <div>
                        <h3 className="loginf">
                          <UserOutlined
                            rev={undefined}
                            className="white-icon"
                          />{" "}
                          REGISTRATI
                        </h3>
                        <p className="loginf2">Benvenuto in Physiocheck App</p>
                      </div>
                    </Col>
                    <Col className="center0" span={4}></Col>
                    <Col className="centero" span={6}>
                      <Form.Item>
                        <Button
                          ref={ref1}
                          type="primary"
                          onClick={() => {
                            setStartVisible(false), setModalVisible(true);
                          }}
                          className="login-boton"
                        >
                          Iscriviti
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Row>
              </Row>
            </>
          )}

          
          {modalVisible && (
            <>
              <Row className="bodysi">
                <Row className="Rower-mz">
                  <Form
                    form={form}
                    name="control-hooks"
                    onFinish={ender}
                    onFinishFailed={onFinishFailed}
                    layout="vertical"
                  >
                    <Row>
                      <Col span={24}>
                        <h3 className="moon">
                          <UserOutlined rev={undefined} /> MODULO DI ISCRIZIONE{" "}
                          <b>*Beta</b>
                        </h3>
                      </Col>
                      {docVisible && (
                        <>
                          <Col className="moon" span={24}>
                            <h4>Dati Dottore</h4>
                            <Col className="formode">
                              <Form.Item
                                name="usernameMaster"
                                rules={[
                                  { required: true, message: "Inserisci l'username" },
                                  { validator: validateUsernameAvailability },
                                ]}
                                
                              >
                                <Input
                                  onChange={(e) =>
                                    setAddStudio({
                                      ...addStudio,
                                      usernameMaster: e.target.value,
                                    })
                                  }
                                  prefix={
                                    <UserOutlined
                                      ref={ref2}
                                      className="site-form-item-icon"
                                      rev={undefined}
                                    />
                                  }
                                  placeholder="Username Login"
                                  className="all-login-formo"
                                />
                              </Form.Item>
                              <Form.Item
                            name="emailMaster"
                            style={{ minWidth: "300px" }}
                            rules={[
                              {
                              required: true,
                              type: "email",
                              message: "Inserisci un'email valida!",
                              },
                              {
                              validator: async (_, value) => {
                                if (!value) {
                                return Promise.reject(
                                  new Error("Inserisci un'email valida!")
                                );
                                }

                                // Chiamata per verificare se l'email è disponibile
                                const availabilityStatus = await checkDoctorEmailAvailability(value);

                                // Controllo del valore ritornato dal backend
                                if (availabilityStatus === "1") {
                                // Se l'email esiste già, mostra l'errore
                                return Promise.reject(
                                  new Error("Email già esistente, scegli un'altra email!")
                                );
                                } else if (availabilityStatus !== "0") {
                                // In caso di errore di connessione o errore interno
                                return Promise.reject(new Error("Errore di connessione o interno"));
                                }

                                // Se l'email è disponibile, accetta il valore
                                return Promise.resolve();
                              },
                              },
                            ]}
                            >
                            <Input
                              onChange={(e) =>
                              setAddStudio({
                                ...addStudio,
                                emailMaster: e.target.value,
                              })
                              }
                              prefix={
                              <MailOutlined
                                ref={ref3}
                                className="site-form-item-icon"
                                rev={undefined}
                              />
                              }
                              placeholder="Email"
                              className="all-login-formo"
                            />
                            </Form.Item>
                              <Form.Item
                                name="passwordMaster"
                                rules={[
                                  {
                                    required: true,
                                    message: "Inserisci la tua password!",
                                  },
                                ]}
                              >
                                <Input
                                  onChange={(e) =>
                                    setAddStudio({
                                      ...addStudio,
                                      passwordMaster: e.target.value,
                                    })
                                  }
                                  prefix={
                                    <LockOutlined
                                      ref={ref4}
                                      className="site-form-item-icon"
                                      rev={undefined}
                                    />
                                  }
                                  type="password"
                                  placeholder="Password"
                                  className="all-login-formo"
                                />
                              </Form.Item>
                            </Col>
                            <Col className="formode">
                              <Form.Item
                                name="passwordMasterConfirmation"
                                dependencies={["passwordMaster"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Conferma la tua password!",
                                  },
                                  ({ getFieldValue }) => ({
                                    validator(_, value) {
                                      if (
                                        !value ||
                                        getFieldValue("passwordMaster") ===
                                          value
                                      ) {
                                        return Promise.resolve();
                                      }
                                      return Promise.reject(
                                        new Error("Le password non coincidono!")
                                      );
                                    },
                                  }),
                                ]}
                              >
                                <Input
                                  onChange={(e) =>
                                    setAddStudio({
                                      ...addStudio,
                                      passwordMasterConfirmation:
                                        e.target.value,
                                    })
                                  }
                                  prefix={
                                    <SafetyOutlined
                                      ref={ref5}
                                      className="site-form-item-icon"
                                      rev={undefined}
                                    />
                                  }
                                  type="password"
                                  placeholder="Conferma Password"
                                  className="all-login-formo"
                                />
                              </Form.Item>
                            </Col>
                          </Col>{" "}
                        </>
                      )}
                      {studioVisible && (
                        <>
                          <Col className="moon" span={24}>
                            <h4>Dati Studio</h4>
                            <Col className="formode">
                            <Form.Item
                          name="nameSignIn"
                          rules={[
                            {
                              required: true,
                              message: "Inserisci il nome di login dello studio!",
                            },
                            {
                              validator: async (_, value) => {
                                if (!value) {
                                  return Promise.reject(
                                    new Error("Inserisci il nome di login dello studio!")
                                  );
                                }

                                // Chiamata per verificare se il nome dello studio è disponibile
                                const availabilityStatus = await checkUsernameAvailability(value);

                                if (Number(availabilityStatus) === 1) {
                                    return Promise.reject(new Error("Studio Login già esistente!"));
                                } else if (Number(availabilityStatus) !== 0) {
                                  return Promise.reject(new Error("Errore di connessione o interno"));
                                }

                                // Se il nome utente è disponibile
                                return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <Input
                            value={addStudio.nameSignIn}
                            onChange={(e) =>
                              setAddStudio({
                                ...addStudio,
                                nameSignIn: e.target.value,
                              })
                            }
                            prefix={<HomeOutlined className="site-form-item-icon" rev={undefined} />}
                            placeholder="Studio Login"
                            className="all-login-formo"
                          />
                        </Form.Item>
                              <Form.Item
                                name="fullName"
                                rules={[
                                  {
                                    required: true,
                                    message:
                                      "Inserisci il nome completo dello studio!",
                                  },
                                ]}
                              >
                                <Input
                                  onChange={(e) =>
                                    setAddStudio({
                                      ...addStudio,
                                      fullName: e.target.value,
                                    })
                                  }
                                  prefix={
                                    <GlobalOutlined
                                      ref={ref7}
                                      className="site-form-item-icon"
                                      rev={undefined}
                                    />
                                  }
                                  placeholder="Nome Studio"
                                  className="all-login-formo"
                                />
                              </Form.Item>


                              <Form.Item
  name="vat"
  labelCol={{ span: 24 }}
  wrapperCol={{ span: 24 }}
  rules={[
    {
      required: true,
      message: "Inserisci la Partita IVA o Codice Fiscale!",
    },
    {
      validator: async (_, value) => {
        if (!value) {
          return Promise.reject(
            new Error("Inserisci la Partita IVA o Codice Fiscale!")
          );
        }

        // Controllo lunghezza valida per Codice Fiscale o Partita IVA
        if (value.length < 11 || value.length > 16) {
          return Promise.reject(new Error("C.F. o P.iva non valido!"));
        }

        // Chiamata per verificare se il codice fiscale è disponibile
        const availabilityStatus = await checkCfAvailability(value);

        // Controllo del valore ritornato dal backend
        if (availabilityStatus === "1") {
          // Se il codice fiscale esiste già, mostra l'errore
          return Promise.reject(
            new Error("Codice Fiscale già esistente, scegli un altro!")
          );
        } else if (availabilityStatus !== "0") {
          // In caso di errore di connessione o errore interno
          return Promise.reject(new Error("Errore di connessione o interno"));
        }

        // Se il codice fiscale è disponibile, accetta il valore
        return Promise.resolve();
      },
    },
  ]}
>
  <Input
    onChange={(e) =>
      setAddStudio({
        ...addStudio,
        vat: e.target.value,
      })
    }
    prefix={
      <IdcardOutlined
        ref={ref8}
        className="site-form-item-icon"
        rev={undefined}
      />
    }
    placeholder="P.Iva / Codice Fiscale"
    className="all-login-formo"
  />
</Form.Item>




                              <Form.Item
                                name="policy"
                                valuePropName="checked"
                                rules={[
                                  {
                                    validator: (_, value) =>
                                      value
                                        ? Promise.resolve()
                                        : Promise.reject(
                                            new Error(
                                              "Devi accettare la privacy policy!"
                                            )
                                          ),
                                  },
                                ]}
                              >
                                <Checkbox required={true}>
                                  <h5 ref={ref9} style={{ minWidth: "300px" }}>
                                    Acconsento al trattamento{" "}
                                    <a href="https://www.physiocheck.it/privacy-policy/">
                                      Privacy & Policy.
                                    </a>
                                  </h5>
                                </Checkbox>
                              </Form.Item>
                            </Col>
                          </Col>
                          <Col className="center" span={4}>
                            <Form.Item>
                              <Button
                                ref={ref10}
                                type="primary"
                                htmlType="submit"
                                className="login-boton-si"
                              >
                                Iscriviti
                              </Button>
                            </Form.Item>
                          </Col>{" "}
                        </>
                      )}

                      {docVisible && (
                        <>
                          <Button
                            ref={ref1}
                            type="primary"
                            onClick={() => {
                              setDocVisible(false), setStudioVisible(true);
                            }}
                            className="login-boton-s"
                          >
                            Successivo
                          </Button>
                        </>
                      )}
                      {studioVisible && (
                        <>
                          <Button
                            ref={ref1}
                            type="primary"
                            onClick={() => {
                              setDocVisible(true), setStudioVisible(false);
                            }}
                            className="login-boton-p"
                          >
                            Precedente
                          </Button>
                        </>
                      )}
                      <Col className="center" span={10}></Col>
                    </Row>
                  </Form>
                </Row>
              </Row>
            </>
          )}
        </>
      )}
      <Row>
        <Popover
          className="orcoleft"
          placement="rightBottom"
          title="Hai già un account?"
          content={contenty}
        >
          <FloatButton
            href={"/app" + LOGIN_PATH}
            icon={<LoginOutlined rev={undefined} />}
            type="default"
            style={{ right: 24 }}
          />
        </Popover>
      </Row>
      <Popover
        placement="leftBottom"
        title="Hai Bisogno Di Aiuto?"
        content={contentx}
      >
        <FloatButton
          icon={<QuestionCircleOutlined rev={undefined} />}
          type="default"
          style={{ right: 24 }}
        />
      </Popover>
    </>
  );
};

export default SubscriptionStudio;
